import { actionCreator } from '@ntersol/state-management';
import { SearchModels } from '../../../routes/houses/shared';

export const searchActions = {
  stateChange: actionCreator<Partial<SearchModels.State>>('STATE_CHANGED'),
};
